import {IconButton, Tooltip} from '@mui/material'
import React from 'react'
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded'
import {useUrlParams} from 'services/hooks'
import BASE_URL from 'store/slices/api/baseUrl'
import {convertToUrlParams} from 'utils'

const LinkIcon = ({link, title}) => {
    const {urlParams} = useUrlParams()

    return (
        <a href={`${BASE_URL}/${link}${convertToUrlParams(urlParams)}`} download={true}>
            <Tooltip title={title}>
                <IconButton>
                    <FileDownloadRoundedIcon />
                </IconButton>
            </Tooltip>
        </a>
    )
}

export default LinkIcon

// const StyledLink = styled(Link)`
//     text-decoration: none;
//     &:hover {
//         background-color: ${Colors.LIGHT_GRAY};
//     }
// `
